import firebase from '@/firebase/firestore';

const state = {
 noteinformation: {
    noteDatas: [],
  },
};
const mutations = {
  setNotes: (state, notedatas) => (state.noteinformation.noteDatas = notedatas),
};
const actions = {
  async fetchNote ({ commit }, userid){
    // 01 ロード画面の表示
    let notedatas = [];

    // 02 データのリアルタイム取得
    await firebase.firestore().collection('user').doc(userid).collection('notes').orderBy("createdAt","asc") //asc desc
    .onSnapshot((querySnapshot) => {
      querySnapshot.docChanges().forEach((change) => {
        // 02-01 データの追加を検出 → ロード画面の非表示 → noprojectの非表示
        if (change.type === "added") {
          notedatas.unshift(change.doc.data());
        }
        // 02-02 データの編集を検出
        if (change.type === "modified") {
          notedatas = [];
          notedatas.push(change.doc.data());
          console.log("Modified : ", change.doc.data());
        }
        // 02-03 データの削除を検出 → ロード画面の非表示
        if (change.type === "removed") {
          notedatas = [];
          notedatas.push(change.doc.data());
        }
      });
    })
    // 03 プロジェクトデータをストアにセット
    commit('setNotes', notedatas)
  },
  async fetchSpecificProjectNote ({ commit }, projectid){
    // 01 ロード画面の表示
    
    let notedatas = [];
    let uid = String(firebase.auth().currentUser.uid)
    let pid = String(projectid)
    
    await firebase.firestore().collection("user").doc(uid).collection("notes")
    .where("projectId", "array-contains", pid)
    .get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
          console.log(doc.id, ' => ', doc.data());
          notedatas.push(doc.data());
      });
    });
    
    // 03 プロジェクトデータをストアにセット
    commit('setNotes', notedatas)
  },
};
const getters = {
  noteInfo: state => state.noteinformation,
};

export default {
  state,
  getters,
  actions,
  mutations,
};